import { render, staticRenderFns } from "./addTrain.vue?vue&type=template&id=6a4a16a8&"
import script from "./addTrain.vue?vue&type=script&lang=js&"
export * from "./addTrain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a4a16a8')) {
      api.createRecord('6a4a16a8', component.options)
    } else {
      api.reload('6a4a16a8', component.options)
    }
    module.hot.accept("./addTrain.vue?vue&type=template&id=6a4a16a8&", function () {
      api.rerender('6a4a16a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/coachmanage/teammanage/component/addTrain.vue"
export default component.exports